import { render } from "./UpsellSalesCart.vue?vue&type=template&id=11fd884d"
import script from "./UpsellSalesCart.vue?vue&type=script&lang=js"
export * from "./UpsellSalesCart.vue?vue&type=script&lang=js"

import "./UpsellSalesCart.vue?vue&type=style&index=0&id=11fd884d&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__